import { render, staticRenderFns } from "./ProFormaDialog.vue?vue&type=template&id=1c4b6daa"
import script from "./ProFormaDialog.vue?vue&type=script&lang=js"
export * from "./ProFormaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports